const theme = {
  colors: {
    white: '#FFFFFF',
    success: '#27D6C0',
    brand: '#803CB5',
    active: '#67B7FF',
    danger: '#eb2f96',

    grey: {
      lightest: '#E8E8E8',
      light: '#D3D7E0',
      primary: '#8F8F8F'
    },

    text: {
      primary: '#242424',
      light: '#4e4e4e',
      secondary: '#77869E',
      highlight: '#72ACE0',
      black: '#171C34',
      grey: '#62686E',
      purple: '#7D3FA8',
    }
  },
  breakpoints: ['540px', '992px', '1280px'],

  fontSizes: [11, 13, 16, 18, 20, 24, 28, 32, 48, 64],

  fontWeights: [400, 600, 800],

  space: [0, 4, 8, 12, 16, 24, 28, 32, 48, 64, 128, 256],
  //      0, 1, 2, 3,  4,  5,  6,  7,  8,  9,   10, 11

  text: {
    title: {
      color: 'text.primary',
      fontSize: [2, 3]
    },
    titlePostFlow: {
      color: 'text.grey',
      fontSize: 3,
      opacity: 0.75,
    },
    paragraph: {
      color: 'text.light',
      fontSize: 2,
      textAlign: 'left',
    },
    subText: {
      color: 'text.secondary',
      fontSize: [1, 2],
      lineHeight: '18px',
      fontWeight: 0,
    },
    heading: {
      color: 'text.primary',
      fontSize: 3,
      fontWeight: 1,
      textAlign: 'center'
    },
    headingPostFlow: {
      color: 'text.black',
      fontSize: 5,
      fontWeight: 0,
      textAlign: 'center'
    },
    text: {
      fontSize: 2,
      fontWeight: 0,
      lineHeight: '17px',
      color: 'text.primary',
    },
    label: {
      fontSize: [4, 6],
      fontWeight: 2,
      lineHeight: '17px',
      color: 'text.primary',
    },
    clickable: {
      fontWeight: 2,
      cursor: 'pointer',
    },
    mutedCTA: {
      backgroundColor: 'grey.lightest',
      color: 'text.light',
      borderRadius: '12px',
    },
    brandCTA: {
      backgroundColor: 'brand',
      color: 'white',
      borderRadius: '12px',
    },
    link: {
      purple: {
        fontSize: 2,
        color: 'text.purple',
        fontWeight: 300,
        cursor: 'pointer',
      }
    },
    signIn: {
      mainHeading: {
        color: 'text.black',
        fontSize: 5,
        fontWeight: 400,
        textAlign: 'center',
      },
      descriptionText: {
        color: 'text.grey',
        fontSize: 2,
        fontWeight: 300,
        textAlign: 'center',
      },
    }
  },

  shadows: {
    button: '0px 0px 8px rgba(101,104,160,0.24);',
    panel: '0px 6px 10px rgba(101,104,160,0.24);',
    choiceGridButton: '1px 1px 24px 0 rgba(206,206,206,0.5)',
  },

  variants: {
    badge: {
      borderRadius: '90px'
    },
    listItem: {
      borderTopStyle: 'solid',
      borderTopColor: 'grey.lightest',
      borderTopWidth: '1px'
    },
    section: {
      borderBottomStyle: 'solid',
      borderBottomColor: 'grey.lightest',
      borderBottomWidth: '1px'
    },
    panel: {
      color: 'text.secondary',
      background: 'white',
      boxShadow: 'button',
      borderRadius: '8px',
      width: '100%'
    },
    note: {
      color: 'text.light',
      backgroundColor: 'grey.lightest',
      borderRadius: '3px',
      width: '100%',
      fontStyle: 'italic',
      padding: 2
    },
  },

  buttons: {
    success: {
      borderStyle: 'solid',
      borderWidth: '1px',
      backgroundColor: 'success',
      borderColor: 'success',
      borderRadius: '6px',
      color: 'white',
      cursor: 'pointer'
    },
    inactive: {
      borderStyle: 'solid',
      borderWidth: '1px',
      backgroundColor: 'grey.primary',
      borderColor: 'grey.primary',
      borderRadius: '6px',
      color: 'white'
    },
    outline: {
      borderStyle: 'solid',
      borderWidth: '1px',
      backgroundColor: 'transparent',
      borderColor: 'grey.primary',
      color: 'grey.primary',
      borderRadius: '6px',
      cursor: 'pointer'
    },
    skip: {
      display: 'block',
      color: 'grey.primary',
      cursor: 'pointer',
      background: 'transparent',
      boxShadow: 'none',
      border: 'none',
      textDecoration: 'underline'
    },
    choiceGridItem: {
      width: '100%',
      outline: 'none',
      borderRadius: '5px',
      boxShadow: 'choiceGridButton',
      backgroundColor: 'white',
      padding: '12px',
      cursor: 'pointer',
      color: 'text.light',
      wordBreak: 'break-word',
    },
    choiceGridItemActive: {
      width: '100%',
      outline: 'none',
      borderRadius: '5px',
      boxShadow: 'choiceGridButton',
      backgroundColor: 'purple',
      padding: '12px',
      cursor: 'pointer',
      color: 'white',
      wordBreak: 'break-word',
    },
    menu: {
      display: 'block',
      color: 'text.secondary',
      cursor: 'pointer',
      background: 'white',
      boxShadow: 'button',
      borderRadius: '8px',
      width: '100%',
      outline: 'none'
    },
    menuActive: {
      outline: 'none',
      display: 'block',
      color: 'white',
      fontWeight: 1,
      cursor: 'pointer',
      backgroundColor: 'active',
      borderRadius: '8px',
      width: '100%'
    },
    link: {
      textDecoration: 'underline',
      background: 'none',
      padding: 0,
      color: 'active',
      cursor: 'pointer',
    },
    linkButton: {
      textDecoration: 'none',
      background: 'none',
      padding: 0,
      cursor: 'pointer',
      color: 'text.purple',
    },
  }
};

export default theme;
